export const SWITCHGEAR_SHEET_MAP = {
  'Filter List *': 0,
  'Pointgroup Keywords *': 1,
  'Open Indicator *': 2,
  'Closed Indicator *': 3,
};

export const SWITCHGEAR_WORKSHEET_NAME = 'switchgear_counter';

export const HEADER_TO_KEY_MAP = {
  'Filter List *': 'filter_list',
  'Pointgroup Keywords *': 'pointgroup_keywords',
  'Open Indicator *': 'open_indicator',
  'Closed Indicator *': 'closed_indicator',
};

export const REQUIRED_SWITCHGEAR_CONFIG_KEYS = Object.values(HEADER_TO_KEY_MAP);

export const SWITCHGEAR_WORKSHEET_COLUMNS = [
  { header: 'Filter List *', key: 'filter_list', width: 25 },
  { header: 'Pointgroup Keywords *', key: 'pointgroup_keywords', width: 25 },
  { header: 'Open Indicator *', key: 'open_indicator', width: 25 },
  { header: 'Closed Indicator *', key: 'closed_indicator', width: 25 },
];

export const SWITCHGEAR_DEFAULT_DATA = {
  filter_list: [
    'operating',
    'order',
    'ordered',
    'alarm',
    'time',
    'supervision',
    'supervisionalarm',
    'supervisionnormal',
    'uncontrolled',
    'command',
    'unsynchronized',
    'off',
    'rejected',
  ],
  open_indicator: ['open', 'opened'],
  closed_indicator: ['close', 'closed'],
  pointgroup_keywords: ['switch', 'breaker', 'disconnector', 'interrupter'],
};

export const WORKSHEET_PROTECTION_OPTIONS = {
  selectLockedCells: true,
  selectUnlockedCells: true,
  formatCells: true,
  formatColumns: false,
  formatRows: false,
  insertColumns: false,
  insertRows: true,
  deleteColumns: false,
  deleteRows: true,
  sort: true,
  autoFilter: true,
};

export const EMPTY_ROWS_COUNT = 500;

export const INFO_ROW_TEXT =
  'Note: The two first rows are locked and fields marked as required (*) need at least one value for the algorithm to run.';
